import { Link, Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen">
      {/* Left: branding */}
      <div className="hidden flex-1 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900 lg:flex lg:flex-col lg:justify-center lg:px-16">
        <Link to="/" className="mb-8 text-3xl font-extrabold text-white">
          동탄 마스터 가이드
        </Link>
        <p className="mb-4 text-xl font-semibold text-primary-100">
          집을 사는 것이 아니라,
          <br />
          미래 자산 전략을 설계하다
        </p>
        <p className="max-w-md text-sm text-primary-200">
          동탄 지역 AI 기반 부동산 초정밀 가치 분석 플랫폼.
          5대 핵심 분석 엔진으로 투자자/실수요자에게 압도적 신뢰 기반 의사결정 도구를 제공합니다.
        </p>
      </div>

      {/* Right: form */}
      <div className="flex flex-1 flex-col items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <Link to="/" className="mb-8 block text-center text-2xl font-bold text-primary-600 lg:hidden">
            동탄 마스터 가이드
          </Link>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
